// extracted by mini-css-extract-plugin
module.exports = {"container":"V6BtwhVj","img":"eAb7nZUI","title":"e9h7gF4I"};